import React from 'react';
// import Header from '../Partial/header/header';
import Footer from '../Partial/footer/footer';
import Navbar from '../Partial/navbar/Navbar';
import Intro from '../LandingPage/intro';
import DealsShow from './dealsShow';
import OurServices from './ourServices';
import PhotoSlider from './bxSlider'
import { Helmet } from 'react-helmet';

export default function LandingPage(){
    return(
        <div>
            <Helmet>
                <title>Dreamer Journey - Home</title>
                <meta name="description" content="Discover amazing journeys and deals with Dreamer Journey." />
            </Helmet>
            {/* <Header/> */}
            <Navbar/>
            <PhotoSlider/>
            <Intro/>
            <OurServices/>
            <DealsShow/>
            <Footer/>
        </div>
    )
}
